import { Employe, GetEmployeResponse, RequestEmploye } from "interfaces/Employe";
import { get, patch, post, remove } from "services/services.methods";
import { EmployePaths, EmployereportPaths } from "services/services.paths";

export const getEmployedListByBranch = async (idBranch: string) => {
  const response = await get<GetEmployeResponse[]>(
    EmployePaths.getByBranch + idBranch
  );

  return response;
};

export const FetchEmployes = async (state?: number | null) => {
  let url = `${EmployereportPaths.getEmploye}`;

  
  url += `?state=${state === null ? 'null' : state}`;

  const response = await get<GetEmployeResponse[]>(url);
  return response;
};




// export const createNewEmploye = async (data: any) => {
//   const response = await post<GetEmployeResponse>(EmployePaths.post, data);

//   return response;
// };



export const createNewEmploye = async (payload: RequestEmploye) => {
  const response = await post<any>(EmployePaths.post, payload);
  
  return response;
};

export const deleteEmploye = async (id: number) => {
  const response = await remove<GetEmployeResponse[]>(
    EmployePaths.delete + `/${id}`
  );

  return response;
};

export const updateEmploye = async (id: number, data: any) => {
  const response = await patch<GetEmployeResponse>(
    EmployePaths.put + `/${id}`,
    data
  );

  return response;
};

export const blockEmployeService = async (id: number) => {
  const response = await patch<any>(EmployePaths.blockUser + `${id}`, {});

  return response;
};
